import ApisService from './index'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'
import { IChiNhanh } from '../interfaces/chiNhanhInterfaces'

export function createChiNhanh(data: IChiNhanh) {
  try {
    return ApisService.post('/chinhanh/create-chinhanh', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateChiNhanh(data: IChiNhanh) {
  try {
    return ApisService.put('/chinhanh/' + data.id + '/update-chinhanh', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailChiNhanh(id: string) {
  try {
    return ApisService.get('/chinhanh/' + id + '/get-chitiet-chinhanh')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListChiNhanh(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/chinhanh/filter-chinhanh', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}
